import React, { useMemo } from 'react';
import { Button, HeadContent, Subsection, Table, Tag, useModalContext, } from '@fourthwall/components';
import { PlusIcon } from '@fourthwall/icons';
import * as S from './PlatformApps.styled';
import { useCreatePlatformAppClient } from './hooks/useCreatePlatformAppClient';
import { useDeletePlatformAppClient } from './hooks/useDeletePlatformAppClient';
import { usePlatformAppClients } from './hooks/usePlatformAppClients';
import { AppDropdown } from './modules/AppDropdown/AppDropdown';
import { CreateAppModal } from './modules/CreateAppModal/CreateAppModal';
export const PlatformApps = () => {
    const { open } = useModalContext();
    const { data: platformAppClients, isLoading: isLoadingPlatformAppClients } = usePlatformAppClients();
    const { deletePlatformAppClient, isLoading: isLoadingDeletePlatformAppClient } = useDeletePlatformAppClient();
    const { createPlatformAppClient, isLoading: isLoadingCreatePlatformAppClient } = useCreatePlatformAppClient();
    const isLoading = isLoadingPlatformAppClients ||
        isLoadingDeletePlatformAppClient ||
        isLoadingCreatePlatformAppClient;
    const apps = useMemo(() => {
        return (platformAppClients
            ?.toSorted((a, b) => a.displayName.localeCompare(b.displayName))
            .map((client) => ({
            id: client.id,
            name: client.displayName,
            status: client.status,
            description: client.description,
            scopes: client.scopes.map((scope) => scope.id),
            redirectUris: client.redirectUris,
            hmacKey: '',
            sections: [],
            createdAt: new Date(),
            updatedAt: new Date(),
        })) || []);
    }, [platformAppClients]);
    const handleAddApp = () => {
        open(CreateAppModal, {
            onSave: (name, description, redirectUris) => {
                createPlatformAppClient([
                    { displayName: name, description, redirectUris, scopes: ['shop_read'] },
                ]);
            },
        });
    };
    const handleDelete = (app) => {
        deletePlatformAppClient([{ clientId: app.id }]);
    };
    const headers = [
        {
            label: 'App Name',
            id: 'name',
            minWidth: 400,
            render: (row) => (React.createElement(S.AppNameCell, null,
                React.createElement(S.AppName, null, row.name),
                row.description && React.createElement(S.AppDescription, null, row.description))),
        },
        {
            label: 'Status',
            id: 'status',
            width: 40,
            render: (row) => {
                if (row.status === 'PUBLISHED') {
                    return React.createElement(Tag, { appearance: "success", label: "Published" });
                }
                if (row.status === 'SUBMITTED') {
                    return React.createElement(Tag, { appearance: "alert", label: "Submitted" });
                }
                return React.createElement(Tag, { appearance: "default", label: "Draft" });
            },
        },
        {
            label: '',
            id: 'actions',
            width: 20,
            render: (row) => React.createElement(AppDropdown, { app: row, onDelete: handleDelete }),
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Managed Apps \u2013 Settings" }),
        React.createElement(Subsection, { title: "Your Apps" },
            React.createElement(S.AppsContainer, null,
                React.createElement(S.HeaderContainer, null,
                    React.createElement("div", null,
                        React.createElement(S.DescriptionText, null, "Manage your apps and their configurations.")),
                    React.createElement(Button, { label: "Create App", icon: React.createElement(PlusIcon, null), appearance: "primary", onClick: handleAddApp })),
                React.createElement(S.TableContainer, null,
                    React.createElement(Table, { headers: headers, data: apps, isLoading: isLoading, emptyMessage: "You don't have any apps yet.", minWidth: 500 }))))));
};
